import { Editor } from '@tinymce/tinymce-react'
import { Modal } from 'antd'
import { globalToaster } from 'components/elements/global'
import {
 useAddNoteMutationMutation,
 useUpdateNoteMutationMutation,
} from 'features/leads'
import { TUserActivityNote } from 'features/leads/types'
import { queryClient } from 'lib/react-query'
import { useGlobal } from 'raducer/global'
import React, { FC, useEffect, useState } from 'react'
import { TMode } from 'types'

const isEmptyContent = (val: string) => !val?.replace(/<[^>]*>/g, '').trim()

const AddNoteModal: FC<{
 visible?: boolean
 onCancel?: () => void
 onSuccess?: () => void
 leadId?: any
 mode?: TMode
 editData?: TUserActivityNote
}> = ({ visible, onCancel, onSuccess, leadId, mode = 'ADD', editData }) => {
 const [content, setContent] = useState('')
 const { global } = useGlobal()

 const [addNote, { isLoading: addLoading }] = useAddNoteMutationMutation()
 const [updateNote, { isLoading: updateLoading }] =
  useUpdateNoteMutationMutation()

 useEffect(() => {
  if (mode === 'EDIT' && editData) {
   setContent(editData?.content ?? '')
  } else {
   setContent('')
  }
  return () => {
   setContent('')
  }
 }, [editData, mode])

 const handleSubmitNote = async () => {
  if (isEmptyContent(content)) {
   globalToaster({ type: 'error', content: 'Please enter note content' })
   return
  }
  if (mode === 'EDIT') {
   await updateNote({ id: editData?.id, content }).unwrap()
  } else {
   await addNote({ content, lead_id: leadId }).unwrap()
  }
  queryClient.invalidateQueries(`lead/profile/${leadId}`)
  setContent('')
  onSuccess?.()
  onCancel?.()
 }

 return (
  <Modal
   title={`${mode === 'EDIT' ? 'Edit' : 'Add'} Note`}
   onCancel={onCancel}
   visible={visible}
   width={600}
   confirmLoading={mode === 'EDIT' ? updateLoading : addLoading}
   okText="Submit"
   onOk={handleSubmitNote}
  >
   <Editor
    value={content}
    onEditorChange={setContent}
    apiKey={global?.tiny_mce_key ?? ''}
    init={{
     menubar: false,
     statusbar: false,
     height: 250,
     plugins: ['lists advlist'],
     toolbar: 'bold italic underline strikethrough | bullist numlist',
     content_style: 'body { font-size: 14px; line-height: 1.5715; }',
    }}
   />
  </Modal>
 )
}

export default AddNoteModal
